import { JSX } from 'react'

import { IconProps } from '../../icon'

const Books: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 49 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <path
      d='M40.9579 34.1161L37.0558 11.3948C36.7924 9.83067 35.3105 8.77693 33.7299 9.04036L28.8564 9.88006C28.2143 9.99531 27.6545 10.3081 27.2264 10.7856C26.6995 10.16 25.9257 9.76481 25.0531 9.76481H20.1137C19.5045 9.76481 18.9282 9.96238 18.4672 10.2917C18.0062 9.96238 17.4299 9.76481 16.8207 9.76481H11.8813C10.3007 9.76481 9 11.0655 9 12.6461V35.6967C9 37.2773 10.3007 38.578 11.8813 38.578H16.8207C17.4299 38.578 18.0062 38.3804 18.4672 38.0511C18.9282 38.3804 19.5045 38.578 20.1137 38.578H25.0531C26.6337 38.578 27.9344 37.2773 27.9344 35.6967V21.537L30.4041 35.9272C30.651 37.3267 31.8694 38.3146 33.2525 38.3146C33.4171 38.3146 33.5818 38.3145 33.7299 38.2652L38.6035 37.4255C39.3609 37.2937 40.0194 36.8821 40.464 36.2565C40.9085 35.6308 41.0896 34.857 40.9579 34.0996V34.1161ZM16.8207 36.1083H11.8813C11.6508 36.1083 11.4697 35.9272 11.4697 35.6967V12.6461C11.4697 12.4156 11.6508 12.2345 11.8813 12.2345H16.8207C17.0512 12.2345 17.2323 12.4156 17.2323 12.6461V35.6967C17.2323 35.9272 17.0512 36.1083 16.8207 36.1083ZM25.4647 35.6967C25.4647 35.9272 25.2836 36.1083 25.0531 36.1083H20.1137C19.8831 36.1083 19.702 35.9272 19.702 35.6967V12.6461C19.702 12.4156 19.8831 12.2345 20.1137 12.2345H25.0531C25.2836 12.2345 25.4647 12.4156 25.4647 12.6461V35.6967ZM38.4553 34.8405C38.4553 34.8405 38.34 34.9887 38.1919 35.0051L33.3183 35.8448C33.0714 35.8778 32.8738 35.7296 32.8408 35.5156L28.9387 12.7943C28.9058 12.6461 28.9716 12.5473 29.0046 12.4815C29.0375 12.4321 29.1198 12.3333 29.268 12.3168L34.1416 11.4771C34.1416 11.4771 34.1909 11.4771 34.2074 11.4771C34.405 11.4771 34.5861 11.6253 34.619 11.8229L38.5212 34.5441C38.5541 34.6923 38.4882 34.8076 38.4553 34.857V34.8405Z'
      fill='black'
    />
  </svg>
)

export default Books
